import { useEffect, useState } from 'react';
import Pusher from 'pusher-js';
import { BASE_URL } from 'utils/config';
import { getConfig } from 'api/admin/pusher/config';

let pusher;

/**
 * Service that creates Pusher instance.
 * Used only once in HomeDashboard after user successfully logged in.
 */
export const initPusher = async () => {
  try {
    const { data } = await getConfig();

    pusher = new Pusher(data.key, {
      cluster: data.cluster,
      authEndpoint: `${BASE_URL}/pusher/auth`,
      auth: {
        headers: {
          authtoken: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.idToken,
          nonce: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.nonce,
          source: 'INTERNAL_MANAGER',
        },
      },
    });

    // Connection successful.
    pusher.connection.bind('connected', function () {
      console.log('Pusher connection successful');
    });

    // Connection error
    pusher.connection.bind('error', function (error) {
      console.error(
        error?.error?.data?.code === 4004
          ? 'Pusher connection limit error'
          : 'Pusher connection error',
        error,
      );
    });
  } catch (e) {
    console.error(e.response?.data?.error || e);
  }
};

/**
 * Hook for using Pusher channel.
 * After component mounting hook will automatically subscribe to the channel.
 * After component unmounting hook will automatically unsubscribe from the channel.
 *
 * @param {string} channelName
 * @returns {Channel}
 */
export const usePusherChannel = (channelName) => {
  const [channel, setChannel] = useState(null);

  useEffect(() => {
    if (!pusher) {
      initPusher();
    }

    if (channelName) {
      const channel = pusher?.subscribe(channelName);
      setChannel(channel);
    }

    return () => {
      if (channelName) {
        pusher.unsubscribe(channelName);
      }
    };
  }, [channelName]);

  return channel;
};
